<template>
  <template v-if="isAuth">
    <NuxtLayout name="base" :page="page" :copyrights="copyrights">
      <component
        v-for="content in page?.content"
        :is="componentMap[content.__component]"
        :key="content.__component"
        :content="content"
      />
    </NuxtLayout>
  </template>
  <p v-else>Not authenticated</p>
</template>

<script setup lang="ts">
const { $aosInit } = useNuxtApp()
const runtimeConfig = useRuntimeConfig()
const componentMap = useContentComponents()
const route = useRoute()
const page = await useFetchPreviewPage()

const copyrights = page.value?.content ? getCopyrights(page.value?.content) : []

provide('copyrights', copyrights)

const { setLocale } = useI18n()
setLocale(page.value?.locale!)

const isAuth =
  route.query.secret &&
  route.query.secret === runtimeConfig.public.previewSecret

onMounted(() => {
  $aosInit()
})

useHead({
  htmlAttrs: {
    lang: route.params.locale as string,
    class: `${runtimeConfig.public.client} overflow-x-hidden font-neo-screen-sans`,
  },
})
</script>
